import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

CanceledAlert.propTypes = {
  sx: PropTypes.object,
};

export default function CanceledAlert({ sx = {} }) {
  const {
    data: { isCanceled },
  } = useSelector((state) => state.transitions);

  return (
    isCanceled && (
      <Alert
        severity="warning"
        sx={[
          {
            justifyContent: 'center',
          },
          sx,
        ]}
      >
        This portfolio has been canceled. You can view the information, but you cannot make any changes.
      </Alert>
    )
  );
}
